import { useSelector } from "react-redux";

import { hasLiveSubscription } from "seneca-common/features/subscriptions/state";

import { createSearchParams, Filters } from "features/course-discovery/utils";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

import { linkToClassPage } from "../../links";

export function linkToAddCoursesPage(classId?: string) {
  return `${linkToClassPage(classId)}/add-courses`;
}

export function linkToAddClassCoursesWithQueryParams(
  classId: string,
  filters?: Filters,
  text?: string
): string {
  return `${linkToAddCoursesPage(classId)}?${createSearchParams(
    filters!,
    text
  )}`;
}

export function linkToAddClassCoursesWithFreeSelected(classId: string) {
  return linkToAddClassCoursesWithQueryParams(classId, {
    price: "Free"
  });
}

export function useGetLinkToAddClassCourses() {
  const userHasSubscription = useSelector(hasLiveSubscription);

  return (classId: string) => {
    if (userHasSubscription || isNativeAppiOS()) {
      return linkToAddCoursesPage(classId);
    } else {
      return linkToAddClassCoursesWithFreeSelected(classId);
    }
  };
}
